module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// ./src/frontend-lib/~/babel-runtime/regenerator/index.js
// module id = 2dev
// module chunks = 0